import React from 'react';

export const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-heading text-base md:text-lg font-bold uppercase tracking-wider text-white mb-3">{title}</h2>
    <div className="space-y-3 text-mono-mute font-body text-sm md:text-base leading-relaxed">{children}</div>
  </section>
);

export const Strong = ({ children }) => <span className="text-white font-semibold">{children}</span>;

export const List = ({ items }) => (
  <ul className="list-disc pl-5 space-y-2">
    {items.map((item, i) => <li key={i}>{item}</li>)}
  </ul>
);

export const Table = ({ head, rows, testid }) => (
  <div data-testid={testid}>
    {/* Phones: one card per row, so nothing hides off the side of the screen. */}
    <div className="md:hidden space-y-3">
      {rows.map((row, i) => (
        <div key={i} className="border border-mono-line bg-mono-card p-4 space-y-2">
          <p className="text-white font-semibold">{row[0]}</p>
          {row.slice(1).map((cell, j) => (
            <div key={j}>
              <p className="font-heading text-[11px] font-bold uppercase tracking-[0.12em] text-mono-mute/70">{head[j + 1]}</p>
              <p className="text-mono-mute text-sm">{cell}</p>
            </div>
          ))}
        </div>
      ))}
    </div>
    <div className="hidden md:block overflow-x-auto border border-mono-line">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="bg-mono-surface border-b border-mono-line">
            {head.map((h) => (
              <th key={h} className="px-3 py-2 font-heading text-xs font-bold uppercase tracking-[0.12em] text-mono-mute whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-b border-mono-line/60 align-top">
              {row.map((cell, j) => (
                <td key={j} className={`px-3 py-2.5 ${j === 0 ? 'text-white' : 'text-mono-mute'}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
